import { combineReducers } from "redux";
import settings from "./settings/reducer";
import menu from "./menu/reducer";
import auth from "./auths/reducers.js";
import messages from "./message/reducers";
import system from "./system/reducers";
import pipes from "./pipes/reducers";
import mno from "./mno/reducers";
import blacklists from "./blacklists/redcuers";
import endpoints from "./endpoints/reducers";
import routePaths from "./routepaths/reducers";
import ussd from "./ussd/reducers";
import sms from "./sms/reducers";
import company from "./company/reducers";
import cp from "./sp/reducers";
import billings from "./billings/reducers";
import reporting from "./reporting/reducers";
import charges from "./charges/reducers";
import priviledges from "./priviledges/reducers";
import users from "./users/reducers";
import wallet from "./wallets/reducers";
import voices from "./voices/reducers";
import campaign from "./company/campaignReducers";
import spemail from "./company/notifierReducer";
import spUsers from "./company/companyUserReducers";
import resubmissions from "./resubmissions/reducers";

const reducers = combineReducers({
  cp,
  mno,
  sms,
  auth,
  menu,
  ussd,
  users,
  pipes,
  voices,
  wallet,
  system,
  spemail,
  charges,
  spUsers,
  company,
  billings,
  campaign,
  settings,
  messages,
  reporting,
  endpoints,
  blacklists,
  routePaths,
  priviledges,
  resubmissions,
});

export default reducers;
